"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcContractProtocolHeader = exports.UcContractEvents = exports.HandoverProtocol = exports.FieldsetHandoverProtocol = void 0;
const FieldsetHandoverProtocol_yaml_component_1 = __importDefault(require("./FieldsetHandoverProtocol.yaml?component"));
exports.FieldsetHandoverProtocol = FieldsetHandoverProtocol_yaml_component_1.default;
const HandoverProtocol_yaml_component_1 = __importDefault(require("./HandoverProtocol.yaml?component"));
exports.HandoverProtocol = HandoverProtocol_yaml_component_1.default;
const UcContractEvents_yaml_component_1 = __importDefault(require("./UcContractEvents.yaml?component"));
exports.UcContractEvents = UcContractEvents_yaml_component_1.default;
const UcContractProtocolHeader_yaml_component_1 = __importDefault(require("./UcContractProtocolHeader.yaml?component"));
exports.UcContractProtocolHeader = UcContractProtocolHeader_yaml_component_1.default;
